module.exports = __webpack_public_path__ + "img/kitchen.ef47abba.svg";